import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    root: {
        display: 'flex', 
        alignItems: 'center', 
        flexDirection: 'column', 
        marginBottom: 8
    },
    title: {
        color: 'hsla(0,0%,100%,.5)',
        width: '100%',
        fontSize: '14px',
        fontFamily: 'PT-sans, sans-serif',
        paddingBottom: 4
    },
    amount: {
        color: '#fff',
        fontSize: 14,
        fontFamily: 'PT-sans, sans-serif',
    }
}))

const BlockHelper = ({title, amount}) => {
    const classes = useStyles();
    
    return (
        <div className={classes.root}>
            <span className={classes.title}>{title}</span>
            <span className={classes.amount}>
                {amount}
            </span>
        </div>
    )
}

export default BlockHelper;